module.exports = __webpack_public_path__ + "img/Correspondence.88c91bc9.png";